import { useQuery } from '@hooks/reactQuery';

import { auth, manageAcquiredAssets } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getAcquiredAssets } from '@api/manageAcquiredAssets';

import { ACQUIRED_ASSETS } from '@constants/queryKeys';
import { endDateTypeOptions } from '@components/routes/AdminPanel/ManageAcquiredAssets/constants';

export const useQueryAcquiredAssets = () => {
	const {
		page,
		pageSize,
		searchValue,
		sortFieldName,
		sortDirection,
		assetTypeId,
		assetSubTypeId,
		assetOwnerId,
		rentStatus,
		datesOverlapType,
		endDateType,
		fromDate,
		toDate,
	} = useAppSelector(manageAcquiredAssets);

	const {
		accessPermission: {
			networkOperatorOrganizationAdministrator,
			networkOperatorAssetViewer,
			networkOperatorAssetEnquirer,
			assetConsumerOrganizationAdministrator,
			assetConsumerAssetEnquirer,
			assetConsumerAssetViewer,
		},
	} = useAppSelector(auth);

	const haveAccessToAcquiredAssets = (
		networkOperatorOrganizationAdministrator ||
		networkOperatorAssetViewer ||
		networkOperatorAssetEnquirer ||
		assetConsumerOrganizationAdministrator ||
		assetConsumerAssetEnquirer ||
		assetConsumerAssetViewer
	);

	const {
		data,
		isLoading: isLoadingAcquiredAssets,
		isFetching: isFetchingAcquiredAssets,
	} = useQuery({
		queryKey: [
			ACQUIRED_ASSETS,
			page,
			pageSize,
			searchValue,
			sortFieldName,
			sortDirection,
			assetTypeId,
			assetSubTypeId,
			assetOwnerId,
			rentStatus,
			datesOverlapType,
			endDateType,
			fromDate,
			toDate,
		],
		queryFn: () => getAcquiredAssets({
			page,
			pageSize,
			searchValue,
			sortFieldName,
			sortDirection,
			assetTypeId,
			assetSubTypeId,
			ownerId: assetOwnerId,
			timeRentType: rentStatus,
			datesOverlapType,
			isActualEndDate: endDateType !== endDateTypeOptions[0].value,
		}, {
			fromDate,
			toDate,
		}),
		refetchOnWindowFocus: false,
		enabled: [haveAccessToAcquiredAssets, !!endDateType],
	});

	return {
		acquiredAssets: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingAcquiredAssets: isLoadingAcquiredAssets || isFetchingAcquiredAssets,
	};
};
